import { render, staticRenderFns } from "./OrderNow.vue?vue&type=template&id=7e94b649&scoped=true&"
import script from "./OrderNow.vue?vue&type=script&lang=js&"
export * from "./OrderNow.vue?vue&type=script&lang=js&"
import style0 from "./OrderNow.vue?vue&type=style&index=0&id=7e94b649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94b649",
  null
  
)

export default component.exports